export interface InviteStateProps {
  inviteesList: string[];
  type: InviteStateType;
  customText?: string;
}

export enum InviteStateType {
  SUCCESS = 1,
  ERROR = 2
}